import { autoinject, customElement } from 'aurelia-framework';
import { DatePickerBaseCustomElement } from 'General/Resources/Elements/DatePicker/DatePickerBase';

@autoinject
@customElement('date-picker')
export class DatePickerCustomElement extends DatePickerBaseCustomElement {}